import { z } from 'zod';
import {
    LineStringGeometry,
    lineStringGeometrySchema,
} from 'app/agriculture/queries/types/geometry/LineStringGeometry';
import {
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';
import {
    PolygonGeometry,
    polygonGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PolygonGeometry';

export interface MapEntity {
    geometry: PointGeometry | LineStringGeometry | PolygonGeometry;
}

export const mapEntitySchema = z
    .object({
        geometry: z.union([pointGeometrySchema, lineStringGeometrySchema, polygonGeometrySchema]),
    })
    // we want this to allow other properties through
    .passthrough();
